import { useMemo } from 'react';

import { AgentParameter, AgentParameterType } from '@frontend/types';

type UseUnusedParametersReturn = {
  unusedParams: Array<AgentParameter<AgentParameterType>>;
};

export function useUnusedParameters(
  parameters: Array<AgentParameter<AgentParameterType>> = [],
  templates: string[] = []
): UseUnusedParametersReturn {
  const unusedParams = useMemo(() => {
    if (!parameters.length) return [];

    const usedVariables = new Set<string>();

    for (const template of templates) {
      const matches = template?.matchAll(/\[\[\s*([^[\]]+?)\s*\]\]/g);
      for (const match of matches ?? []) {
        // Decode HTML entities and trim whitespace
        const decodedVariable = match[1].replace(/&nbsp;/g, ' ').trim();
        usedVariables.add(decodedVariable);
      }
    }

    return parameters.filter(param => !usedVariables.has(param.name));
  }, [parameters, templates]);
  return {
    unusedParams,
  };
}
